import {
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_SUCCESS,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_FAIL,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_SUCCESS,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_FAIL,
  ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER,
  ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
  UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER,
  UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
  DELETE_GOOD_SERVICES_SUB_HEAD_MASTER,
  DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
} from "./actionTypes"

export const getGoodServicesSubHeadMasterList = () => ({
  type: GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST,
})

export const getGoodServicesSubHeadMasterListSuccess = goodServicesSubHeads => ({
  type: GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_SUCCESS,
  payload: goodServicesSubHeads,
})
export const getGoodServicesSubHeadMasterListFail = error => ({
  type: GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_FAIL,
  payload: error,
})

export const getGoodServicesSubHeadMasterDetail = goodServicesSubHeadId => ({
  type: GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL,
  goodServicesSubHeadId,
})

export const getGoodServicesSubHeadMasterDetailSuccess = goodServicesSubHeadDetail => ({
  type: GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_SUCCESS,
  payload: goodServicesSubHeadDetail,
})

export const getGoodServicesSubHeadMasterDetailFail = error => ({
  type: GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_FAIL,
  payload: error,
})

export const addNewGoodServicesSubHeadMaster = (goodServicesSubHead, history) => ({
  type: ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER,
  payload: { goodServicesSubHead, history },
  status: true,
})

export const addNewGoodServicesSubHeadMasterSuccess = goodServicesSubHead => ({
  type: ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  payload: goodServicesSubHead,
})

export const addNewGoodServicesSubHeadMasterFail = error => ({
  type: ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
  payload: error,
})

export const updateGoodServicesSubHeadMaster = (id, goodServicesSubHead, history) => ({
  type: UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER,
  payload: { id, goodServicesSubHead, history },
})

export const updateGoodServicesSubHeadMasterSuccess = goodServicesSubHead => ({
  type: UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  payload: goodServicesSubHead,
})

export const updateGoodServicesSubHeadMasterFail = error => ({
  type: UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
  payload: error,
})

export const deleteGoodServicesSubHeadMaster = goodServicesSubHead => ({
  type: DELETE_GOOD_SERVICES_SUB_HEAD_MASTER,
  payload: goodServicesSubHead,
})

export const deleteGoodServicesSubHeadMasterSuccess = goodServicesSubHead => ({
  type: DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  payload: goodServicesSubHead,
})

export const deleteGoodServicesSubHeadMasterFail = error => ({
  type: DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
  payload: error,
})
